/** O chat interno não tem canal de atendimento, então não existe registro em
 *  `attachmentssettings/all` (usado nas mensagens com clientes) para ele. Tamanho e
 *  tipo de arquivo são decididos pelo backend, que recusa o upload quando for o caso:
 *  o front não replica esses limites para não divergir deles.
 */

/** Único limite ainda checado aqui: o nome estourado quebra a montagem do anexo
 *  antes mesmo de o upload começar.
 */
export const INTERNAL_ATTACHMENT_MAX_FILE_NAME_LENGTH = 150;

/** Os erros são devolvidos como descritores `{ id, values }` em vez de texto pronto:
 *  a formatação depende do `react-intl`, que só existe na camada de componente.
 *  Assim esta função continua pura e testável.
 */
export const filterInternalAttachments = (files) => {
    const acceptedFiles = [];
    const errors = [];

    files.forEach(file => {
        if (file.name.length > INTERNAL_ATTACHMENT_MAX_FILE_NAME_LENGTH) {
            errors.push({
                id: "O nome do arquivo {fileName} excede o limite de {maxLength} caracteres",
                values: {
                    fileName: file.name,
                    maxLength: INTERNAL_ATTACHMENT_MAX_FILE_NAME_LENGTH
                }
            });
            return;
        }

        acceptedFiles.push(file);
    });

    return { acceptedFiles, errors };
}

/** O download de anexos internos é servido pela Corporate Chat API, numa rota
 *  diferente da usada pelas mensagens com clientes (`messageattachments`).
 *  Quando o anexo não traz o messageId, a API expõe a rota sem ele.
 */
export const getInternalAttachmentUrl = (attachment, messageId) => {
    if (!attachment || !attachment.storageName) return null;

    const baseUrl = `${process.env.REACT_APP_CORPORATECHAT_API_URL}/${process.env.REACT_APP_API_URI}/corporatemessageattachments`;
    const attachmentMessageId = attachment.messageId || messageId || null;

    if (attachmentMessageId) {
        return `${baseUrl}/${attachmentMessageId}/download/${attachment.storageName}`;
    }

    return `${baseUrl}/download/${attachment.storageName}`;
}

/** Anexo de grupo usa a `url` que vem da API e, na falta dela, a rota sem messageId:
 *  a rota com messageId é da conversa individual, e o id aqui é de mensagem de grupo.
 */
export const getInternalGroupAttachmentUrl = (attachment) => {
    if (!attachment) return null;
    if (attachment.url) return attachment.url;
    if (!attachment.storageName) return null;

    return `${process.env.REACT_APP_CORPORATECHAT_API_URL}/${process.env.REACT_APP_API_URI}/corporatemessageattachments/download/${attachment.storageName}`;
}

/** Uma mensagem só com anexo vem sem texto; a lista de conversas e o hover-card
 *  mostram o nome do arquivo no lugar para não ficar em branco.
 */
export const getLastMessagePreview = (messageText, attachments) => {
    return messageText || (attachments && attachments[0] && attachments[0].fileName) || '';
}
